/*======================================================================
============================ REPORT TYPES ==============================
======================================================================*/
export {
  DocumentExtractionStatus,
  DocumentSide,
  DocumentType,
  DocumentTypeKYB,
  DocumentTypeKYC,
  ReportAutofillStatus,
  ReportDecision,
  ReportStatus,
  ReportType,
  RiskLevel,
  SignalResolution,
  SignalType,
} from '../schema/report';
